import React, { Component } from 'react';
import { Field, FieldArray, reset } from 'redux-form'
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data, CheckboxEditor } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, ButtonToolbar, Button} from 'react-bootstrap';
import ContentWrapper from '../Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import { SkyLightStateless } from 'react-skylight';
import _ from 'lodash';
import { Selection } from '../Common/selection';
import { InputField, DisabledInputField } from '../Common/inputField';
import { Translate, Localize } from 'react-redux-i18n';

import PackageTypes from '../../containers/Products/packageTypes';

import {
  ROOT_URL, ROOT_API_URL, companyCodeTitle, isHMM, isGFD, isOLG, isGGI, isVAK,
  isSV, isLMH, isSDR, isCRW,
} from '../../actions/root_url';
const isEcity = ROOT_API_URL === "https://ctstage-scm.truckxi.com/api/"|| ROOT_API_URL === 'https://ct-scm.truckxi.com/api/' || ROOT_API_URL === "https://dev-scm.truckxi.com/api/";
const isJTB = ROOT_API_URL === 'https://jtb-scm.truckxi.com/api/' || ROOT_URL === 'https://jtb-scm.truckxi.com/api/';

const createPackageTypesDialogStyle = {
  width: '650px',
  marginLeft: '-15%',
}

class RowRenderer extends Component {
    render() {
        return (<div onDoubleClick={ ()=>{ this.props.onDoubleClick(this.props.row, this.props.field) } } ><ReactDataGrid.Row ref="row" {...this.props} /></div>)
    }
}

let sizeRadios = props => {
  return (
    <div className="form-group">
      <div className="col-xs-6 text-nowrap">
          <input {...props.input} type="radio" value="true"
            checked={props.input.value === true || props.input.value === "true"}/>
          <Translate value="msg_large_prod"/>
      </div>
      <div className="col-xs-6 text-nowrap">
          <input {...props.input} type="radio" value="false"
            checked={props.input.value === false || props.input.value === "false"}/>
          <Translate value="msg_small_prod"/>
      </div>
    </div>
  )
}

let convertNumRadios = props => {
  return (
    <div className="form-group">
      <div className="col-sm-5 text-nowrap">
          <input {...props.input} type="radio" value="weight"
            checked={props.input.value === "weight"}/>
          <Translate value="by_weight"/>
      </div>
      <div className="col-sm-5 text-nowrap">
          <input {...props.input} type="radio" value="unit"
            checked={props.input.value === "unit"}/>
          <Translate value="by_unit"/>
      </div>
    </div>
  )
}

 export class ProductFormNavigation_1 extends Component {
  constructor() {
    super();
    this.state = {
      gfdGroupOptions: [],
      group: null,
      category: null,
      department: null,
      suggestedProdNum: null,
      isLinked: false,
      linkProdOpen: false,
      products: {
        rows: [],
        filters: {},
        selectedRows: [],
        sortColumn: null,
        sortDirection: null,
      },
      initial: false
    }
    this.openLinkProd = this.openLinkProd.bind(this);
    this.closeLinkProd = this.closeLinkProd.bind(this);
    this.selectExistingProd = this.selectExistingProd.bind(this);
    this.clearFields = this.clearFields.bind(this);
  }

  componentWillMount() {
    if(this.props.formContent) {
      this.props.setValue('productFormNavigation_1', 'Department', this.props.formContent.ProductDepartment_id)
      this.props.setValue('productFormNavigation_1', 'Category', this.props.formContent.ProductCategory1_id)
      this.props.setValue('productFormNavigation_1', 'Group', this.props.formContent.ProductGroup_id)
      this.props.setValue('productFormNavigation_1', 'Name', this.props.formContent.Name)
      this.props.setValue('productFormNavigation_1', 'Description', this.props.formContent.Description)
      this.props.setValue('productFormNavigation_1', 'IsLarge', this.props.formContent.IsLarge)
      if (isSV || isGFD || isVAK || isOLG) {
        this.props.setValue('productFormNavigation_1', 'IsLarge', false)
      }
      this.props.setValue('productFormNavigation_1', 'LastDigit', this.props.formContent.LastDigit)
      if (isLMH || isSDR || isCRW) {
        this.props.setValue('productFormNavigation_1', 'IsLarge', false);
        // this.props.setValue('productFormNavigation_1', 'LastDigit', "1");
      }
      if (isVAK || isGFD) {
        this.props.setValue('productFormNavigation_1', 'LastDigit', "1");
      }
      let suggestedProdNum = this.props.formContent.suggestedProdNum
      let isLinked = this.props.formContent.isLinked
      this.setState({suggestedProdNum, isLinked})
    }
    if(this.props.formContent.suggestedProdNum) {
      this.setState({initial: true})
    }
  }

  componentWillReceiveProps(nextProps) {
    if(isGFD && nextProps.Department && nextProps.Department != this.props.Department) {
      this.props.fetchDepCategories(nextProps.Department.value || nextProps.Department);

      let indexDeps = _.findIndex(this.props.deps, {ProductDepartment_id: nextProps.Department.value || nextProps.Department})
      if(indexDeps > -1) {
        let department = { ...this.props.deps[indexDeps] };
        if(department.DepartmentNum.length < 2) {
          department.DepartmentNum = "0" + department.DepartmentNum;
        }
        this.setState({ department })
      }
      
      if (nextProps.Department) {
        this.props.setValue('productFormNavigation_1', 'Group', null);
        this.props.setValue('productFormNavigation_1', 'Category', null);
        // this.props.setValue('productFormNavigation_1', 'IsLarge', null);
        // this.props.setValue('productFormNavigation_1', 'LastDigit', null);
        this.setState({group: null, category: null, suggestedProdNum: null, isLinked: false })
      }
    }
    let gfdTemp = [];
    if (nextProps.depCategories && nextProps.depCategories.length > 0) {
      nextProps.depCategories.map((r,i) => {
        gfdTemp.push({label: r.Name, value: r.ProductGroup_id});
      });
      this.setState({gfdGroupOptions: gfdTemp});
    } else {
      this.setState({gfdGroupOptions: []});
    }

    if(nextProps.Group && nextProps.Group != this.props.Group) {
      this.props.fetchGroupCategories(nextProps.Group.value || nextProps.Group);
      let index = _.findIndex(this.props.groups, {ProductGroup_id: nextProps.Group.value || nextProps.Group})
      if(index > -1) {
        let group = { ...this.props.groups[index] };
        if(group.GroupNum.length < 2) {
          group.GroupNum = "0" + group.GroupNum;
        }
        this.setState({ group })
      }
      if(this.props.Group) {
        this.props.setValue('productFormNavigation_1', 'Category', null);
        if (!(isVAK || isGFD)) {
          this.props.setValue('productFormNavigation_1', 'IsLarge', null);
          this.props.setValue('productFormNavigation_1', 'LastDigit', null);
        }
        this.setState({category: null, suggestedProdNum: null, isLinked: false })
      }
    }
    if(nextProps.Category && nextProps.Category != this.props.Category) {
      let index = _.findIndex(this.props.groupCategories, {ProductCategory_id: nextProps.Category.value || nextProps.Category})
      if(index > -1) {
        this.setState({category: this.props.groupCategories[index]})
      }
      this.props.fetchSuggestedProdNum(this.props.groupCategories[index].ProductCategory_id)
      if(this.props.Category) {
        if (!(isVAK || isGFD)) {
          this.props.setValue('productFormNavigation_1', 'IsLarge', null);
          this.props.setValue('productFormNavigation_1', 'LastDigit', null);
        }
      }
    }
    if((nextProps.suggestedProdNumFetched !== null) && nextProps.suggestedProdNumFetched != this.props.suggestedProdNumFetched) {
      if(this.state.initial) {
        this.setState({initial: false});
      }
      else {
        this.setState({suggestedProdNum: nextProps.suggestedProdNumFetched, isLinked: false})
        if (!(isVAK || isGFD)) {
          this.props.setValue('productFormNavigation_1', 'IsLarge', null);
          this.props.setValue('productFormNavigation_1', 'LastDigit', null);
        }
      }
    }
    if(nextProps.existingProd && nextProps.existingProd != this.props.existingProd) {
      let products = {...this.state.products, rows: nextProps.existingProd}
      this.setState({products})
    }
    if(nextProps.IsLarge && nextProps.IsLarge != this.props.IsLarge) {
      if(nextProps.IsLarge == "false" || nextProps.IsLarge == false) {
        this.props.setValue('productFormNavigation_1', 'LastDigit', "1");
        this.props.clearSuggestDigit();
      }
      else {
        if(this.state.group && this.state.category && this.state.suggestedProdNum) {
          let prodNum = `${this.state.group.GroupNum}${this.state.category.CategoryNum}${this.state.suggestedProdNum}`
          this.props.fetchSuggestDigit(prodNum);
        }
        if(this.props.IsLarge !== undefined) {
          this.props.setValue('productFormNavigation_1', 'LastDigit', null);
        }
      }
    }
  }

  clearFields() {
    this.props.setValue('productFormNavigation_1', 'Department', null);
    this.props.setValue('productFormNavigation_1', 'Category', null);
    this.props.setValue('productFormNavigation_1', 'Group', null);
    this.props.setValue('productFormNavigation_1', 'Name', null);
    this.props.setValue('productFormNavigation_1', 'Description', null);
    this.props.setValue('productFormNavigation_1', 'IsLarge', null);
    this.props.setValue('productFormNavigation_1', 'LastDigit', null);
    this.setState({group: null, category: null, suggestedProdNum: null, isLinked: false })
  }

  selectExistingProd(prod) {
    let suggestedProdNum = prod.ProductNum.slice(4, 7);
    this.setState({suggestedProdNum, isLinked: true, linkProdOpen: false})
    this.props.setValue('productFormNavigation_1', 'IsLarge', null);
    this.props.setValue('productFormNavigation_1', 'LastDigit', null);
  }

  getDepOptions() {
    var productDepOptions = [];
    if(this.props.deps) {
      this.props.deps.map(dep => {
        if (localStorage.getItem('lang') === 'en') {
          productDepOptions.push({value: dep.ProductDepartment_id, label: dep.Name})
        } else {
          productDepOptions.push({value: dep.ProductDepartment_id, label: dep.Description})
        }
      });
    }
    return productDepOptions;
  }

  getGroupOptions() {
    var productGroupOptions = [];
    if(this.props.groups) {
      this.props.groups.map(group => {
        if (localStorage.getItem('lang') === 'en') {
          productGroupOptions.push({value: group.ProductGroup_id, label: group.Name})
        } else {
          productGroupOptions.push({value: group.ProductGroup_id, label: group.Description})
        }
      });
    }
    return productGroupOptions;
  }

  getCategoryOptions() {
    let categoryOptions = [];
    this.props.groupCategories.map(category => {
      if (localStorage.getItem('lang') === 'en') {
        categoryOptions.push({value: category.ProductCategory_id, label: category.Name})
      } else {
        categoryOptions.push({value: category.ProductCategory_id, label: category.Description})
      }
    })
    return categoryOptions;
  }

  getLastDigitOptions() {
    let lastDigitOptions = [{value: "1", label: "1"}];
    if(this.props.IsLarge && this.props.suggestDigitFetched) {
      lastDigitOptions = [];
      this.props.suggestDigitFetched.map(digit => {
        lastDigitOptions.push({value: digit, label: digit})
      })
    }
    return lastDigitOptions;
  }

  openLinkProd() {
    this.state.products.filters = {};
    this.setState({linkProdOpen: true});
  }

  closeLinkProd() {
    this.setState({linkProdOpen: false});
  }

  renderExistingProd() {
    if (this.props.existingProdIsLoading && !this.props.existingProdError) return <Spinner/>
    else if (this.props.existingProdError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.existingProdError)}</div></ContentWrapper>
    else {
        // Parameters of the react-data-grid

        const getRows = () => {
            return Data.Selectors.getRows(this.state.products);
        }

        const getSize = () => {
            return getRows().length;
        }

        const rowGetter = rowIdx => {
            var rows = getRows();
            return rows[rowIdx];
        }

        // Handle the sortable function

        const handleGridSort = (sortColumn, sortDirection) => {
            var products = Object.assign({}, this.state.products, { sortColumn: sortColumn, sortDirection: sortDirection });
            this.setState({products});
        }

        const handleFilterChange = (filter) => {
          let newFilters = Object.assign({}, this.state.products.filters);
          if (filter.filterTerm) {
            newFilters[filter.column.key] = filter;
          } else {
            delete newFilters[filter.column.key];
          }
          const products = { ...this.state.products, filters: newFilters };
          this.setState({ products });
        }

        const onClearFilters = () => {
          // all filters removed
          const products = { ...this.state.products, filters: {} };
          this.setState({ products });
        };

        // Column difinition

        const columns = [
          {
              key: 'ProductNum',
              name: <Translate value="prod_num"/>,
              filterable: true,
              resizable: true,
              sortable: true,
              width: 100,
              // filterRenderer: FilterByStart,
          },
          {
              key: 'RefNum',
              name: <Translate value={isOLG ? "item_no" : "ref_num"}/>,
              filterable: true,
              resizable: true,
              sortable: true,
              width: 90,
              // filterRenderer: FilterByStart,
          },
          {
              key: 'Name',
              name: <Translate value="prod_name"/>,
              filterable: true,
              resizable: true,
              sortable: true,
              width: 300,
          },
          {
              key: 'Description',
              name: <Translate value="description"/>,
              filterable: true,
              resizable: true,
              sortable: true,
          },
        ]

        return (
            <Row><Col sm={ 12 }><div style={{ maxWidth: '100%', marginTop: '10px' }} id="ProductFormNavigation-dataGrid1">
                <ReactDataGrid
                    enableCellSelect={true}
                    rowRenderer={<RowRenderer onDoubleClick={this.selectExistingProd} />}
                    rowKey='Product_id'
                    rowHeight={25}
                    headerRowHeight={45}
                    minHeight={350}
                    toolbar={<Toolbar enableFilter={true} />}
                    onAddFilter={handleFilterChange}
                    onClearFilters={onClearFilters}
                    onGridSort={handleGridSort}
                    columns={columns}
                    rowGetter={rowGetter}
                    rowsCount={getSize()}
                />
            </div></Col></Row>
        )
    }
  }

  render() {
    const groupOptions = this.getGroupOptions();
    const categoryOptions = this.getCategoryOptions();
    const lastDigitOptions = this.getLastDigitOptions();
    const depOptions = this.getDepOptions()

    let createDialogStyle = {
        width: '800px',
        height: '500px',
        marginLeft: '-15%',
    };

    let lastDigit = this.props.LastDigit && (this.props.LastDigit.value || this.props.LastDigit);
    if(lastDigit && (typeof lastDigit == "object")) {
      lastDigit = 0;
    }
    let ProductNum = `${this.state.group && this.state.group.GroupNum}${this.state.category && this.state.category.CategoryNum}${this.state.suggestedProdNum && this.state.suggestedProdNum}${lastDigit}`;
    if (isVAK) {
      ProductNum = `${this.state.group && this.state.group.GroupNum}${this.state.category && this.state.category.CategoryNum}${this.state.suggestedProdNum && this.state.suggestedProdNum}`;
    }
    if (isGFD) {
      // ProductNum = "";
      ProductNum = `${this.state.department && this.state.department.DepartmentNum}${this.state.group && this.state.group.GroupNum.slice(-2)}${this.state.category && this.state.category.CategoryNum.slice(-2)}${this.state.suggestedProdNum && this.state.suggestedProdNum}`;
  }
    return (
      <ContentWrapper>
        <div className="create-a-new-product-form" id="manage-products">
        {!isGFD &&
        <Row className="product-num-header">
          <label className="mr-md"><Translate value="prod_num"/></label>
            {this.state.group && <label className="prod-num-border">{this.state.group.GroupNum}</label>}
            {this.state.category && <label className="prod-num-border">{this.state.category.CategoryNum}</label>}
            {this.state.suggestedProdNum && <label className="prod-num-border">{this.state.suggestedProdNum}</label>}
            {!isVAK && this.props.LastDigit && <label className="prod-num-border">{lastDigit}</label>}
        </Row>
  }
  {isGFD &&
   <Row className="product-num-header">
   <label className="mr-md"><Translate value="prod_num"/></label>
   {this.state.department && <label className="prod-num-border">{this.state.department.DepartmentNum}</label>}
     {this.state.group && <label className="prod-num-border">{this.state.group.GroupNum.slice(-2)}</label>}
     {this.state.category && <label className="prod-num-border">{this.state.category.CategoryNum.slice(-2)}</label>}
     {this.state.suggestedProdNum && <label className="prod-num-border">{this.state.suggestedProdNum}</label>}
 </Row>
  }
        <Panel className="product-form-navigation-1">
          {
            isGFD &&
            <Row>
            <label className="col-xs-5"> <span className="primary">00</span> <Translate value="please_select_department" /><span className="asteriksReq">*</span></label>
            {/* <Col xs={ 1 }>{ this.state.group && this.state.group.GroupNum }</Col> */}
            <Col xs={ 6 }><Field name="Department" component={Selection} options={depOptions}/></Col>
          </Row>
          }
          <Row>
            <label className="col-xs-5"> <span className="primary">01</span> <Translate value={isJTB ? "please_select_customer_group" : "please_select_group"} /><span className="asteriksReq">*</span></label>
            {!isGFD && <Col xs={ 1 }>{ this.state.group && this.state.group.GroupNum }</Col> }
            <Col xs={ 6 }><Field name="Group" component={Selection} options={isGFD ? this.state.gfdGroupOptions : groupOptions}/></Col>
          </Row>
          <Row>
            <label className="col-xs-5"> <span className="primary">02</span> <Translate value="please_select_category" /><span className="asteriksReq">*</span></label>
            {!isGFD && <Col xs={ 1 }>{ this.state.category && this.state.category.CategoryNum }</Col> }
            <Col xs={ 6 }><Field name="Category" component={Selection} options={categoryOptions}/></Col>
          </Row>
          <Row>
            <label className="col-xs-5"> <span className="primary">03</span> <Translate value="new_series_no" /><span className="asteriksReq">*</span></label>
            <Col xs={ 3 }><Field name="SeriesNum" component={DisabledInputField} placeholder={this.state.suggestedProdNum}/></Col>
            <Col xs={ 1 }></Col>
            <Col xs={ 3 }><Button bsStyle="primary" disabled={isVAK} onClick={()=>{this.props.fetchProductsByCategory(this.state.category.ProductCategory_id);this.openLinkProd()}}><Translate value="link_existing_prod" /></Button></Col>
          </Row>
          <Row>
            <label className="col-xs-1"> <span className="primary">04</span></label>
            <Col xs={ 7 } className="sizeRadios">
              <Field name="IsLarge" component={ sizeRadios }/>
            </Col>
            <span className="asteriksReq pAbs">*</span>
            <Col xs={ 4 }>
              <Field name="LastDigit" component={ Selection } options={ lastDigitOptions }/>
            </Col>
          </Row>
        </Panel>
        <Row className="product-form-navigation-1">
          <label className="col-xs-5 product-name"> <span className="primary">05</span> <Translate value="prod_name" /></label>
          <Col xs={ 7 }><Field name="Name" component={InputField} /></Col>
        </Row>
        <Row className="product-form-navigation-1 mb0">
          <label className="col-xs-5 product-name"> <span className="primary">06</span> <Translate value="description" /></label>
          <Col xs={ 7 }><Field name="Description" component={InputField} /></Col>
        </Row>
        <Row className="mb0">
          <label className="col-xs-5 nonbold-label-description"><Translate value="(chinese)" /></label>
        </Row>
        <ButtonToolbar>
          <Button onClick={this.clearFields}>
            <Translate value="clear"/>
          </Button>
          <Button
            disabled={!this.props.Category || !this.props.Group || !this.state.suggestedProdNum || (!lastDigit && lastDigit != 0)}
            onClick={()=>{ this.props.handleClickNext(
              this.props.Department,
              this.props.Category,
              this.props.Group,
              this.state.suggestedProdNum,
              this.state.isLinked,
              this.props.Name,
              this.props.Description,
              this.props.IsLarge,
              this.props.LastDigit,
              ProductNum,
              ProductNum,
            ) }
          }>
            <Translate value="next"/>
          </Button>
        </ButtonToolbar>
        </div>
        <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.linkProdOpen} onCloseClicked={() => { this.closeLinkProd() } }>
          {this.renderExistingProd()}
        </SkyLightStateless>
      </ContentWrapper>
    )
  }
}

export class ProductFormNavigation_2 extends Component {
 constructor() {
   super();
   this.state = {
     packageTypeOpen: false,
     packageTypes: {
       rows: [],
       selectedRows: [],
       sortColumn: null,
       sortDirection: null,
     }
   }
   this.openPackageType = this.openPackageType.bind(this);
   this.closePackageType = this.closePackageType.bind(this);
   this.selectPackageType = this.selectPackageType.bind(this);
   this.clearFields = this.clearFields.bind(this);
 }

 componentWillMount() {
    this.props.fetchPackageTypes();
    this.props.fetchMeasurementUnit();
    if(this.props.formContent) {
      this.props.setValue('productFormNavigation_2', 'ProdType', this.props.formContent.ProdType);
      this.props.setValue('productFormNavigation_2', 'PackageType', this.props.formContent.PackageType);
      this.props.setValue('productFormNavigation_2', 'PackageSize_1', this.props.formContent.PackageSize_1);
      this.props.setValue('productFormNavigation_2', 'PackageType_2', this.props.formContent.PackageType_2);
      this.props.setValue('productFormNavigation_2', 'PackageSize_2', this.props.formContent.PackageSize_2);
      this.props.setValue('productFormNavigation_2', 'MeasureUnit_2', this.props.formContent.MeasureUnit_2);
      this.props.setValue('productFormNavigation_2', 'NetWeight_1', this.props.formContent.NetWeight_1);
      this.props.setValue('productFormNavigation_2', 'NetWeight_2', this.props.formContent.NetWeight_2);
      if (isOLG) {
        this.props.setValue('productFormNavigation_2', 'ProductCost', this.props.formContent.ProductCost);
      }
      this.props.setValue('productFormNavigation_2', 'RefPrice', this.props.formContent.RefPrice);
      this.props.setValue('productFormNavigation_2', 'LowestSalePrice', this.props.formContent.LowestSalePrice);

      if (isSV) {
        this.props.setValue('productFormNavigation_2', 'ProdType', 'Fixed');
        this.props.setValue('productFormNavigation_2', 'PackageSize_1', 1);
        this.props.setValue('productFormNavigation_2', 'PackageSize_2', 1);
      }

      if(!this.props.formContent.MeasureUnit_2) {
        this.props.setValue('productFormNavigation_2', 'MeasureUnit_2', 'LB');
      }
      if(!this.props.formContent.NetWeight_2) {
        this.props.setValue('productFormNavigation_2', 'NetWeight_2', 'LB');
      }

      if (isLMH || isSDR || isCRW) {
        this.props.setValue('productFormNavigation_2', 'ProdType', 'Fixed');
        this.props.setValue('productFormNavigation_2', 'PackageType', 'btl');
        this.props.setValue('productFormNavigation_2', 'PackageSize_1', 1);
        this.props.setValue('productFormNavigation_2', 'PackageSize_2', 1);
        this.props.setValue('productFormNavigation_2', 'PackageType_2', 'btl');
        this.props.setValue('productFormNavigation_2', 'MeasureUnit_2', 'box');
        this.props.setValue('productFormNavigation_2', 'NetWeight_1', 1);
        this.props.setValue('productFormNavigation_2', 'NetWeight_2', 'box');
      }
   }
 }

 componentWillReceiveProps(nextProps) {
   if(nextProps.packageTypesFetched && nextProps.packageTypesFetched != this.props.packageTypesFetched) {
     let packageTypes = {...this.state.packageTypes, rows: nextProps.packageTypesFetched}
     this.setState({packageTypes})
   }
 }

 getProdTypeOptions() {
   let prodTypeOptions = [
       { value: "Fixed", label: "Fixed" },
       { value: "Non-Fixed", label: "Non-Fixed" },
       { value: "Service", label: "Service" },
       { value: "Non-Product", label: "Non-Product" },
       { value: "Per-Pound", label: "Per-Pound" },
       { value: "Other", label: "Other" }
   ];
   if (isGFD) {
    prodTypeOptions.splice(5,0, {
      value: 'Gift-Card',
      label: 'Gift-Card',
    });
   }
   return prodTypeOptions;
 }

 getMeasureUnitOptions() {
   let measureUnitOptions = [];
   if(this.props.measurementUnitFetched) {
     this.props.measurementUnitFetched.map(measureUnit => {
       measureUnitOptions.push({value: measureUnit.Simple, label: measureUnit.Simple})
     })
   }
 return measureUnitOptions;
 }

 getPackageTypeOptions() {
   let packageTypeOptions = [];
   if(this.props.packageTypesFetched) {
     this.props.packageTypesFetched.map((packageType, i) => {
       packageTypeOptions.push({value: packageType.Simple, label: packageType.Simple})
     })
   }
   return packageTypeOptions;
 }

 openPackageType() {
   this.setState({packageTypeOpen: true})
 }

 closePackageType() {
   this.setState({packageTypeOpen: false})
 }

 selectPackageType(row, field) {
   this.props.setValue("productFormNavigation_2", field, row.Simple);
   this.closePackageType();
 }

 clearFields() {
   this.props.setValue('productFormNavigation_2', 'ProdType', null);
   this.props.setValue('productFormNavigation_2', 'PackageType', null);
   this.props.setValue('productFormNavigation_2', 'PackageSize_1', null);
   this.props.setValue('productFormNavigation_2', 'PackageType_2', null);
   this.props.setValue('productFormNavigation_2', 'PackageSize_2', null);
   this.props.setValue('productFormNavigation_2', 'MeasureUnit_2', null);
   this.props.setValue('productFormNavigation_2', 'NetWeight_1', null);
   this.props.setValue('productFormNavigation_2', 'NetWeight_2', null);
   if (isOLG) {
    this.props.setValue('productFormNavigation_2', 'ProductCost', null);
   }
   this.props.setValue('productFormNavigation_2', 'RefPrice', null);
   this.props.setValue('productFormNavigation_2', 'LowestSalePrice', null);
 }

 shouldNextBtnDisable = () => {
   return !this.props.ProdType;
 }
 render() {
   const prodTypeOptions = this.getProdTypeOptions();
   const measureUnitOptions = this.getMeasureUnitOptions();
   const weightOptions = [
     {
       value: "lb",
       label: "lb"
     },
     {
       value: "kg",
       label: "kg"
     },
   ]
   const packageTypeOptions = this.getPackageTypeOptions();
   return (
     <ContentWrapper>
       <div className="create-a-new-product-form" id="manage-products">
       <Panel>
         <Row>
           <label className="col-xs-3"> <span className="primary">07</span> <Translate value="prod_type"/><span className="asteriksReq">*</span></label>
           <Col xs={4}><Field name="ProdType" component={Selection} options={prodTypeOptions}/></Col>
         </Row>
         <Row>
         <label className="col-xs-3"> <span className="primary">08</span> <Translate value="package_type" /></label>
           <Col xs={ 4 }><Field name="PackageType" component={Selection} options={packageTypeOptions}/></Col>
         </Row>
         {!isSV && 
         <Row>
           <label className="col-xs-3"> <span className="primary">09</span> <Translate value="package_size" /></label>
           <Col xs={ 2 }><Field name="PackageSize_1" component={InputField} /></Col>
           {
             !isEcity &&
             <Col xs={ 2 }><Field name="PackageType_2" component={Selection} options={packageTypeOptions}/></Col>
           }
           {
            isEcity &&
            <Col xs={ 2 }><Field name="PackageType_2" component={InputField} placeholder="Type"/></Col>
           }
           <Col xs={ 1 } className="textAlignStyle"><em className="fa fa-times times-sign"/></Col>
           <Col xs={ 2 }><Field name="PackageSize_2" component={InputField} /></Col>
           {
             !isEcity &&
             <Col xs={ 2 }><Field name="MeasureUnit_2" component={Selection} options={measureUnitOptions}/></Col>
           }
           {
            isEcity &&
            <Col xs={ 2 }><Field name="MeasureUnit_2" component={InputField} placeholder="Unit" /></Col>
           }
         </Row>
 }
 {
  !isSV &&
         <Row>
           <label className="col-xs-3"> <span className="primary">10</span> <Translate value="net_weight" /></label>
           <Col xs={ 2 }><Field name="NetWeight_1" component={InputField} /></Col>
           <Col xs={ 2 }><Field name="NetWeight_2" component={Selection} options={measureUnitOptions}/></Col>
         </Row>
 }
           {
             isOLG &&
             <Row>
               <label className="col-xs-5"> <span className="primary">11</span> <Translate value="product_cost" /></label>
               <label className="new-product-form-dollar-sign">$</label><Col xs={4}><Field name="ProductCost" component={InputField} /></Col>
             </Row>
           }
         <Row>
           <label className="col-xs-5"> <span className="primary">{ isOLG ? 12 : 11}</span> <Translate value="ref_price" /></label>
           <label className="new-product-form-dollar-sign">$</label><Col xs={ 4 }><Field name="RefPrice" component={InputField} /></Col>
         </Row>
         <Row>
           <label className="col-xs-5 nonbold-label"><Translate value="(all_markup_percentsign_will_base_on_this_price)" /></label>
         </Row>
         <Row>
           <label className="col-xs-5"> <span className="primary">{isOLG ? 13 : 12 }</span> <Translate value="lowest_sale_dollarsign" /></label>
           <label className="new-product-form-dollar-sign">$</label><Col xs={ 4 }><Field name="LowestSalePrice" component={InputField} /></Col>
         </Row>
         <Row>
           <label className="col-xs-5 nonbold-label"><Translate value="(no_sale_will_be_allowed_lower_than_this_price)" /></label>
         </Row>
       </Panel>
       <ButtonToolbar>
         <Button onClick={this.clearFields}>
           <Translate value="clear" />
         </Button>
         <Button onClick={()=>{this.props.handleClickPrev(
           this.props.ProdType,
           this.props.PackageType,
           this.props.PackageSize_1,
           this.props.PackageType_2,
           this.props.PackageSize_2,
           this.props.MeasureUnit_2,
           this.props.NetWeight_1,
           this.props.NetWeight_2,
           this.props.ProductCost,
           this.props.RefPrice,
           this.props.LowestSalePrice,
           )}}>
           <Translate value="previous"/>
         </Button>
         <Button disabled={isVAK && this.shouldNextBtnDisable()} onClick={()=>{this.props.handleClickNext(
             this.props.ProdType,
             this.props.PackageType,
             this.props.PackageSize_1,
             this.props.PackageType_2,
             this.props.PackageSize_2,
             this.props.MeasureUnit_2,
             this.props.NetWeight_1,
             this.props.NetWeight_2,
             this.props.ProductCost,
             this.props.RefPrice,
             this.props.LowestSalePrice,
           )}}>
             {
               isHMM &&
               <Translate value="finish"/>
             }
             {
               !isHMM &&
               <Translate value="next"/>
             }
         </Button>
       </ButtonToolbar>
       </div>
       <SkyLightStateless dialogStyles={createPackageTypesDialogStyle} isVisible={this.state.packageTypeOpen} onCloseClicked={()=>{this.closePackageType()}}>
         <PackageTypes selectPackageType={this.selectPackageType} field={this.state.field}/>
       </SkyLightStateless>
     </ContentWrapper>
   )
 }
}

export class ProductFormNavigation_3 extends Component {
 constructor() {
   super();
   this.state = {
     packageTypeOpen: false,
     packageTypes: {
       rows: [],
       selectedRows: [],
       sortColumn: null,
       sortDirection: null,
     }
   }
   this.openPackageType = this.openPackageType.bind(this);
   this.closePackageType = this.closePackageType.bind(this);
   this.selectPackageType = this.selectPackageType.bind(this);
   this.handleClickFinish = this.handleClickFinish.bind(this);
   this.clearFields = this.clearFields.bind(this);
 }

 componentWillMount() {
   this.props.fetchPackageTypes();
   if (!isVAK) {
     this.props.fetchConvertableProducts(this.props.ProductNum, 'create');
   }
   this.props.setValue('productFormNavigation_3', 'ConvertNum', this.props.formContent.ConvertNum)
   this.props.setValue('productFormNavigation_3', 'SmallProdType', this.props.formContent.SmallProdType)
   this.props.setValue('productFormNavigation_3', 'SmallPackageType', this.props.formContent.SmallPackageType)
   this.props.setValue('productFormNavigation_3', 'ConvertType', this.props.formContent.ConvertType)
   if (isSV) {
    this.props.setValue('productFormNavigation_3', 'ConvertType', 'unit')
   }
   if (isLMH || isSDR || isCRW) {
    this.props.setValue('productFormNavigation_3', 'ConvertType', 'unit')
   }
 }

 componentWillReceiveProps(nextProps) {
   if(nextProps.packageTypesFetched && nextProps.packageTypesFetched != this.props.packageTypesFetched) {
     let packageTypes = {...this.state.packageTypes, rows: nextProps.packageTypesFetched}
     this.setState({packageTypes})
   }
   if(nextProps.convertableProductsFetchError && nextProps.convertableProductsFetchError != this.props.convertableProductsFetchError) {
     console.log("61", nextProps.convertableProductsFetchError)
   }
 }

 openPackageType() {
   this.setState({packageTypeOpen: true})
 }

 closePackageType() {
   this.setState({packageTypeOpen: false})
 }

 selectPackageType(row) {
   this.props.setValue("productFormNavigation_3", "SmallPackageType", row.Simple);
   this.closePackageType();
 }

 handleClickFinish() {
   this.props.saveProductFormNavigation_3(
     this.props.ConvertNum,
     this.props.SmallProdType,
     this.props.SmallPackageType,
     this.props.ConvertType,
     this.props.GeneralNum,
   );
   this.props.closeNavigation();
  //  this.props.handleClickFinish()
 }

 clearFields() {
   this.props.setValue('productFormNavigation_3', 'ConvertNum', null);
   this.props.setValue('productFormNavigation_3', 'SmallProdType', null);
   this.props.setValue('productFormNavigation_3', 'SmallPackageType', null);
   this.props.setValue('productFormNavigation_3', 'ConvertType', null);
   if (isVAK) {
     this.props.setValue('productFormNavigation_3', 'GeneralNum', null);
   }
 }

 renderConvertableProducts() {
   if (this.props.fetchingConvertableProducts && !this.props.convertableProductsFetchError) {
     return <Spinner />;
   }
   if (this.props.convertableProductsFetched
     && this.props.convertableProductsFetched
     && this.props.convertableProductsFetched.relations.length > 0) {
     let index = 1;
     const twoDigits = (index)=>{
       return ('0'+index).toString().slice(-2);
     }
     return(
       <Col xs={ 12 } className="convertable-products">
         {this.props.convertableProductsFetched.relations.map(prod =>
           <Row>
             <Col sm={ 1 }>{twoDigits(index++)}</Col>
             <Col sm={ 3 }>{prod.ProductNum}</Col>
             <Col sm={ 3 }>{prod.PackageSize}</Col>
             <Col sm={ 3 }>{prod.ProductType}</Col>
           </Row>
         )}
       </Col>
     )
   }
  return
 }

 render() {
   const test = [
     {value: "1", label: "21"},
     {value: "2", label: "2"},
   ]
   const SmallProdTypeOptions = [
     {
       value: "Fixed", label: "Per-Unit"
     },
     {
       value: "Per-Pound", label: "Per-Weight"
     },
   ]
   return (
     <ContentWrapper>
       <div className="create-a-new-product-form" id="manage-products">
         {!(isOLG || isGGI) && <Row>
           <label className="col-xs-5"> <span className="primary">13</span> <Translate value="convert" /></label>
           <Col xs={ 7 }><Field name="ConvertType" component={convertNumRadios} /></Col>
         </Row>}
         <Row>
           <label className="col-xs-5"> <span className="primary">{ isGGI ? 13 : 14}</span> <Translate value="convertable_product" /></label>
         </Row>
         {isVAK && <Row>
           <label className="col-xs-5"> <span className="primary">15</span> <Translate value="general_no"/></label>
           <Col xs={ 5 }><Field name="GeneralNum" component={InputField} /></Col>
         </Row>}
         <Panel id="panel-scroll-bar">
           {this.renderConvertableProducts()}
         </Panel>
         <ButtonToolbar>
           <Button onClick={this.clearFields}>
             <Translate value="clear" />
           </Button>
           <Button onClick={()=>{this.props.handleClickPrev(
               this.props.ConvertNum,
               this.props.SmallProdType,
               this.props.SmallPackageType,
               this.props.ConvertType,
               this.props.GeneralNum,
             )}}>
             <Translate value="previous"/>
           </Button>
           <Button
             onClick={()=>{this.handleClickFinish()}}
             disabled={
               !this.props.ProductGroup_id ||
               !this.props.ProductCategory1_id ||
               (!this.props.suggestedProdNum && !isGFD) ||
               !this.props.LastDigit
             }
           >
             <Translate value="finish"/>
           </Button>
         </ButtonToolbar>
       </div>
       <SkyLightStateless dialogStyles={createPackageTypesDialogStyle} isVisible={this.state.packageTypeOpen} onCloseClicked={()=>{this.closePackageType()}}>
         <PackageTypes selectPackageType={this.selectPackageType}/>
       </SkyLightStateless>
     </ContentWrapper>
   )
 }
}

export default ProductFormNavigation_1;



// WEBPACK FOOTER //
// ./master/jsx/components/Products/productFormNavigation.jsx